export default __webpack_public_path__ + "static/media/right-image.bcdabc47.png";